import React from 'react';
import { ApiStore, Subscribe } from 'Store';

// Components
import { Header, Anchor } from 'Components/core';
import Card from 'Components/Card';
import CardContainer from 'Components/Card/CardContainer';

// Icons
import AlarmIcon from 'Icons/magnifying.svg';
import MedkitIcon from 'Icons/explore.svg';
import StethoscopeIcon from 'Icons/new_stethoscope.svg';
import CODES from 'Root/libs/analytics/CodeDef';
import styled from 'styled-components';

const headerStyle = {
  fontFamily: 'Elevance Sans Semibold',
  fontSize: 24,

  color: '#333'
};

const LinkedCard = styled(Card)`


  img{
    //cursor: pointer;
  }
  
  a {
    color: #1355e9 !important;
    cursor: pointer;
  }

  a{
    :hover {
    
      text-decoration: underline;
      }

  }
`;

export default props => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <CardContainer>
        <LinkedCard>
          <div>
            <img
              alt="Explore"
              src={MedkitIcon}
              style={{ width: '44px', height: '44px' }}
            />
          </div>
          <Header>
            {state.includeMedical ? (
              <Anchor
                style={headerStyle}
                code={CODES.INTERNAL_MD}
                to="/benefits/medical"
                underline={false}
              >
                Explore your plan options
              </Anchor>
            ) : (
              <span style={headerStyle}>Explore your plan options</span>
            )}
          </Header>
          <p>Choose the right plan for you</p>
        </LinkedCard>

        <LinkedCard>
          <div>
            <img
              alt="Provider"
              src={AlarmIcon}
              style={{ width: '44px', height: '44px' }}
            />
          </div>
          <Header>
            <Anchor
              style={headerStyle}
              code={CODES.INTERNAL_MD}
              to="/find-a-provider"
              underline={false}
            >
              Provider directory search
            </Anchor>
          </Header>
          <p>Find a Provider</p>
        </LinkedCard>
        {false && (
          <Card>
            <div>
              <img
                alt="Alarm"
                src={AlarmIcon}
                style={{ width: '4em', height: '4em' }}
              />
            </div>
            <Header>
              {typeof state.oeMaterials?.enrollURL === 'string' ? (
                <Anchor
                  code={CODES.READY_TO_ENROLL}
                  to={state.oeMaterials.enrollURL}
                  underline={false}
                >
                  Ready to enroll?
                  <br />
                  Get started
                </Anchor>
              ) : (
                <span>
                  {' '}
                  Ready to enroll?
                  <br />
                  Get started
                </span>
              )}
            </Header>
            {state?.oeMaterials?.enrollPara && (
              <p>{state.oeMaterials.enrollPara}</p>
            )}
          </Card>
        )}
        <LinkedCard>
          <div>
            <img
              alt="Learn how  your plan works"
              src={StethoscopeIcon}
              style={{ width: '44px', height: '44px' }}
            />
          </div>
          <Header>
            <Anchor
              style={headerStyle}
              code={CODES.INTERNAL_HPW}
              to="/benefits/how-plan-works"
              underline={false}
            >
              Learn how your plan works
            </Anchor>
          </Header>
          <p>
            Common terms, how to choose a health plan and more.{' '}
            {state?.oeMaterials?.oeBrochure?.oeBrochureURL &&
              (state?.oeMaterials?.oeBrochure?.oeBrochureURL + '').length >
                0 && (
                <Anchor
                  code={CODES.EBO_URL}
                  to={state?.oeMaterials?.oeBrochure?.oeBrochureURL}
                  underline={false}
                >
                  Plus, view or download the Open Enrollment Booklet.
                </Anchor>
              )}
          </p>
        </LinkedCard>
      </CardContainer>
    )}
  </Subscribe>
);
